"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = Object.prototype.hasOwnProperty.call.bind(Object.prototype.hasOwnProperty);

exports.default = _default;